import { AppRoutePathParam } from './app-route-path-param.enum';
import { AppRoutePath } from './app-route-path.enum';

/**
 * Map of the respective path params per app route.
 */
export const appRoutePathParams = {
  [AppRoutePath.VehicleLength]: [
    AppRoutePathParam.Subprocess,
    AppRoutePathParam.Country,
    AppRoutePathParam.Language,
    AppRoutePathParam.VehicleClass,
    AppRoutePathParam.VehicleBody
  ],
  [AppRoutePath.Motorization]: [
    AppRoutePathParam.Subprocess,
    AppRoutePathParam.Country,
    AppRoutePathParam.Language,
    AppRoutePathParam.VehicleClass,
    AppRoutePathParam.VehicleBody
  ],
  [AppRoutePath.Configuration]: [
    AppRoutePathParam.Subprocess,
    AppRoutePathParam.Country,
    AppRoutePathParam.Language,
    AppRoutePathParam.VehicleId
  ],
  [AppRoutePath.ConfigurationStep]: [
    AppRoutePathParam.Subprocess,
    AppRoutePathParam.Country,
    AppRoutePathParam.Language,
    AppRoutePathParam.VehicleId,
    AppRoutePathParam.ConfigurationStep
  ]
};
